<template>
  <div>
    <TemplateItemMobile :template="template" />
    <TemplateItemDesktop :template="template" />
  </div>
</template>

<script>
import TemplateItemMobile from './Mobile/Template';
import TemplateItemDesktop from './Desktop/Template';

export default {
  data() {
    return {}
  },
  props: ['template'],
  components: { TemplateItemMobile, TemplateItemDesktop }
}
</script>
